import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Hero = () => {
  return (
    <div className='p-12 bg-waves bg-cover lg:px-36 lg:h-screen space-y-3 lg:grid grid-cols-2'>
      <div className='lg:text-left md:my-auto lg:mt-10 xl:mx-8'>
        <h1 className=' tracking-tight font-extrabold text-gray-900 lg:text-3xl 2xl:text-5xl text-2xl'>
          <span className='block xl:inline'>
            Maximizing Students’ Potential
          </span>{' '}
          <span className='block xl:inline'>
            Through Customized Therapeutic and Academic Programs
          </span>
        </h1>
        <div className='bg-lightest p-6 rounded-lg shadow-lg text-left max-w-fit'>
          <p className='mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0'>
            As an official business partner of Alberta’s Family Supports for
            Children with Disabilities (FSCD) program, Link and Learn offers
            100% customized therapy programs for students with autism, ADHD and
            other neurological differences. Our custom tailored academic lessons
            are perfect for students of all ages and levels, especially those
            with special needs and those seeking accelerated learning. Link and
            Learn’s academic and therapeutic teams work holistically to maximize
            your child’s potential while catering all sessions specifically to
            your child’s needs and learning persona. Book your complimentary
            holistic assessment today!
          </p>
          <div className='mt-5 sm:mt-8 sm:flex sm:justify-center lg:justify-start'>
            <motion.button
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              className='rounded-md shadow'
            >
              <Link
                to='/contact'
                className='w-full flex items-center justify-center px-8 py-3 border border-transparent font-medium rounded-md text-white bg-darkest hover:bg-blue-200 md:py-4 md:text-lg md:px-10'
              >
                Book a Free Holistic Assessment
              </Link>
            </motion.button>
          </div>
        </div>
      </div>
      <div>
        <img
          className='sm:mx-auto h-auto rounded-3xl drop-shadow-2xl 2xl:mt-9 lg:mt-24'
          src='/home.png'
          alt=''
        />
      </div>
    </div>
  );
};

export default Hero;
